import { useState } from "react";
import { AnswerOption, CreateAnswerOptionInput } from "../../API";
import { QueryStatus } from "../../app/types";
import {
  deleteAnswerOption as deleteAnswerOptionAPI,
  createAnswerOption as createAnswerOptionAPI
} from "./answerOptionAPI";

export const useDeleteAnswerOption = () => {
  const [deletedAnswerOption, setDeletedAnswerOption] =
    useState<AnswerOption | null>(null);
  const [status, setStatus] = useState<QueryStatus>("idle");
  const [error, setError] = useState<string | null>(null);

  const deleteAnswerOption = async (id: string) => {
    setStatus("loading");
    setError(null);

    try {
      const deletionResult = await deleteAnswerOptionAPI(id);
      setDeletedAnswerOption(deletionResult);
      setStatus("succeeded");
      return deletionResult;
    } catch (error) {
      console.error("error in deleteAnswerOption:", error);
      const errorString = JSON.stringify(error);
      setStatus("failed");
      setError(errorString);
    }
    return null;
  };
  return {
    deletedAnswerOption,
    status,
    error,
    deleteAnswerOption
  };
};

export const useCreateAnswerOption = () => {
  const [createdAnswerOption, setCreatedAnswerOption] =
    useState<AnswerOption | null>(null);
  const [status, setStatus] = useState<QueryStatus>("idle");
  const [error, setError] = useState<string | null>(null);

  const createAnswerOption = async (input: CreateAnswerOptionInput) => {
    setStatus("loading");
    setError(null);

    try {
      const creationResult = await createAnswerOptionAPI(input);
      setCreatedAnswerOption(creationResult);
      setStatus("succeeded");
      return creationResult;
    } catch (error) {
      console.error("error in createAnswerOption:", error);
      const errorString = JSON.stringify(error);
      setStatus("failed");
      setError(errorString);
    }
    return null;
  };
  return {
    createdAnswerOption,
    status,
    error,
    createAnswerOption
  };
};
